import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import divide from 'notebook/tables/excess/util/divide';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';
import sum from 'notebook/tables/excess/util/sum';

export default {
  name: 'STDEV',
  shortDescription: 'Standard deviation based on a sample.',
  category: FunctionCategory.STATS,
  description: 'Calculates the standard deviation based on a sample.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first value or range of the sample.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'Additional values or ranges to include in the sample.',

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    const mean = divide(sum(numberValues), numberValues.length, 'STDEV');
    const sqdiffs = numberValues.map((value) => Math.pow(value - mean, 2));
    return Math.sqrt(divide(sum(sqdiffs), sqdiffs.length - 1, 'STDEV'));
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
